import { render, staticRenderFns } from "./MovimientosTarimaPageComponent.vue?vue&type=template&id=45f4790a&"
import script from "./MovimientosTarimaPageComponent.vue?vue&type=script&lang=js&"
export * from "./MovimientosTarimaPageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports